<qrcode
  [qrdata]="qrData"
  [width]="width"
  [errorCorrectionLevel]="errorCorrectionLevel"
  [elementType]="'img'"></qrcode>
